import { convertToImperialDate } from "app/codes";
import React, { useEffect, useMemo, useState } from "react";
import { getWellEvents, getAssetWellEvents } from "service/events";

function EventLogTable(props) {
  const { wellId, assetId, search = "" } = props;
  const { loadingIconActions } = props;
  const [showLoadingIcon, hideLoadingIcon] = loadingIconActions || [];
  const [data, setData] = useState(null);

  useEffect(() => {
    if (wellId == null && assetId == null) {
      return;
    }

    showLoadingIcon && showLoadingIcon();
    const onOk = (result) => {
      setData(Array.isArray(result) ? result : []);
      hideLoadingIcon && hideLoadingIcon();
    };
    const onErr = () => {
      hideLoadingIcon && hideLoadingIcon();
    };
    if (wellId != null) {
      getWellEvents(wellId, onOk, onErr);
    } else if (assetId != null) {
      getAssetWellEvents(assetId, onOk, onErr);
    }
  }, [wellId, assetId, hideLoadingIcon, showLoadingIcon]);

  // AV-D5: make the search functional (was a dead scaffold control).
  const rows = useMemo(() => {
    if (!data) return null;
    const term = search.trim().toLowerCase();
    if (!term) return data;
    return data.filter((item) => {
      const hay = [
        item.well_name,
        item.event,
        item.status,
        item.lead,
        item.description,
      ]
        .filter(Boolean)
        .join(" ")
        .toLowerCase();
      return hay.includes(term);
    });
  }, [data, search]);

  return (
    <>
      <table className="table table-borderless table-centered table-nowrap">
        <thead>
          <tr>
            <th>Well</th>
            <th>Event Type</th>
            <th>Start Date</th>
            <th>Duration (Days)</th>
            <th>Status</th>
            <th>Lead Person</th>
            <th>Contact</th>
          </tr>
        </thead>
        {rows && (
          <tbody>
            {rows.map((item, index) => {
              return (
                <tr key={item.id ?? index}>
                  <td>{item.well_name}</td>
                  <td>{item.event}</td>
                  <td>{convertToImperialDate(item.start_date)}</td>
                  <td>{item.duration}</td>
                  <td>{item.status}</td>
                  <td>{item.lead}</td>
                  <td>{item.contact}</td>
                </tr>
              );
            })}
          </tbody>
        )}
      </table>
    </>
  );
}

export default EventLogTable;
